import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { style: {"margin-top":"12px","margin-left":"12px"} }
const _hoisted_2 = { class: "calendar" }

import TimePlannerComponent from "@/components/infra/TimePlannerComponent.vue"

import { watch, reactive, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TimePlannerComponent_Stand',
  setup(__props) {

const model = reactive({span: 0, date2: new Date()})


watch(()=>model.date2, function(o,n){

    console.log('outside update:' + o)
})

const log:string[] = reactive([])

const dateTimeEditor = ref<InstanceType<typeof TimePlannerComponent> | null>(null)

function run(){

    const x = dateTimeEditor.value?.date_result()!

    const y = dateTimeEditor.value?.span_result()!

    //log.push(x.toDateString() + ' : ' + x.addMilliseconds.toTimeString())

    log.push(x.toString() + ' | ' + y)

}


return (_ctx: any,_cache: any) => {
  const _component_v_date_picker = _resolveComponent("v-date-picker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TimePlannerComponent, {
        modelValue: model.date2,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.date2) = $event)),
        span: model.span,
        ref_key: "dateTimeEditor",
        ref: dateTimeEditor
      }, null, 8, ["modelValue", "span"]),
      _createElementVNode("div", { style: {"margin-top":"1em"} }, [
        _createElementVNode("button", { onClick: run }, "Run")
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_date_picker, {
        modelValue: model.date2,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model.date2) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(log, (l, i) => {
        return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(l), 1))
      }), 128))
    ])
  ], 64))
}
}

})